<template>
  <span>
    <!-- Plain text for a type the viewer cannot render; the row's preview button says why. -->
    <button
      v-if="canView"
      type="button"
      class="btn btn-link p-0 document-name-link text-left"
      :disabled="isViewing"
      @click.stop="$emit('view', document)"
    >
      <span
        v-if="isViewing"
        class="spinner-border spinner-border-sm mr-1"
      ></span>
      <truncated-text :text="document.original_file_name" max="40ch" />
    </button>
    <span v-else class="document-name-plain"
      ><truncated-text :text="document.original_file_name" max="40ch"
    /></span>
  </span>
</template>

<script>
import { isViewable } from "./useDocumentsArea";

export default {
  name: "DocumentNameLink",
  props: {
    document: { type: Object, required: true },
    /** The table owns one viewer for every row, so it owns the loading state too. */
    isViewing: { type: Boolean, default: false },
  },
  emits: ["view"],
  computed: {
    canView() {
      return isViewable(this.document);
    },
  },
};
</script>

<style scoped>
/* Inherits the theme's text colour rather than Bootstrap's fixed link blue. */
.document-name-link {
  color: var(--main-text-color);
  text-decoration: none;
  font-weight: 500;
  vertical-align: baseline;
  max-width: 100%;
  min-width: 0;
}

.document-name-link:hover,
.document-name-link:focus {
  color: var(--main-text-color);
  text-decoration: underline;
}

.document-name-link:disabled {
  opacity: 0.6;
}

.document-name-plain {
  max-width: 100%;
  min-width: 0;
}
</style>
